/**
 * Section A6 Service
 * A.6.參與方 API 服務
 *
 * 注意: axios 攔截器會自動從 localStorage 讀取 txn_token 並添加到所有請求的 header
 * Service 層不需要手動傳遞 txn_token 參數
 */

import axios from '../api/axios';

const BASE_URL = '/api/section-a6';

// ========== Types ==========

export interface SectionA6Detail {
  id: number;
  organization_id: number;
  project_id: number;
  party_type: number;
  party_name: number;
  party_name_cname?: string;
  party_name_ename?: string;
  activity_participant: string | null;
  a6_percentage: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface SectionA6Create {
  project_id: number;
  party_type: number;
  party_name: number;
  activity_participant?: string;
}

export interface SectionA6Update {
  party_type?: number;
  party_name?: number;
  activity_participant?: string;
}

// ========== API ==========

/**
 * 根據專案 ID 取得 A.6 資料清單
 */
export const getListByProject = async (projectId: number): Promise<SectionA6Detail[]> => {
  const response = await axios.get<SectionA6Detail[]>(`${BASE_URL}/by-project/${projectId}`);
  return response.data;
};

/**
 * 新增 A.6 資料
 */
export const create = async (data: SectionA6Create): Promise<SectionA6Detail> => {
  const response = await axios.post<SectionA6Detail>(BASE_URL + '/', data);
  return response.data;
};

/**
 * 更新 A.6 資料
 */
export const update = async (id: number, data: SectionA6Update): Promise<SectionA6Detail> => {
  const response = await axios.put<SectionA6Detail>(`${BASE_URL}/${id}`, data);
  return response.data;
};

/**
 * 刪除 A.6 資料
 */
export const deleteItem = async (id: number): Promise<void> => {
  await axios.delete(`${BASE_URL}/${id}`);
};

const sectionA6Service = {
  getListByProject,
  create,
  update,
  delete: deleteItem
};

export default sectionA6Service;
